import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../Dashboard.css';
import { Modal, Input, Button, Space, Typography, Alert } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const { Text } = Typography;

const PasswordModal = ({ isOpen, onClose, onConfirm, errorMessage }) => {
    const { t } = useTranslation();
    const [password, setPassword] = useState('');

    useEffect(() => {
        if (errorMessage) {
            setPassword(''); // Clear password if there's an error message
        }
    }, [errorMessage]);

    const handleConfirm = () => {
        onConfirm(password);
    };

    return (
        <Modal
            title={t('confirmDeletion')}
            open={isOpen}
            onCancel={onClose}
            footer={null}
            destroyOnClose={true}
            maskClosable={false}
            centered
        >
            <div style={{ padding: '10px 0' }}>
                <Text>{t('enterPasswordToDelete')}</Text>
                
                <div style={{ margin: '20px 0' }}>
                    <Input.Password
                        prefix={<LockOutlined />}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder={t('password')}
                        onPressEnter={handleConfirm}
                    />
                </div>
                
                {errorMessage && (
                    <Alert
                        message={t(errorMessage)}
                        type="error"
                        showIcon
                        style={{ marginBottom: '20px' }}
                    />
                )}
                
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onClose}>
                            {t('cancel')}
                        </Button>
                        <Button type="primary" onClick={handleConfirm} disabled={!password.trim()}>
                            {t('confirm')}
                        </Button>
                    </Space>
                </div>
            </div>
        </Modal>
    );
};

export default PasswordModal;